class Agency {
  id = null;

  name = "";
  subdomain = "";
  logo = "";
  email = "";
  phone = "";
  address = "";
  bankname = "";
  bankaccountname = "";
  iban = "";
  workfield = "";
  parentagencyid = null;
  active = true;

  username = "";
  password = "";

  isdebtok = false;
  debtlimit = 0;

  sendtowgroup = true;
  hascreditcard = false;

  insurance_price_ratios = null;
  forcelogodisplay = false;
  loyalty = null;
  labels = null;

  createdby = "";
  updatedby = "";

  note = "";

  static getFormData(object, isPutMethod = false) {
    console.log("creating form data ....");
    const formData = new FormData();
    formData.append("name", object.name);
    formData.append("all", object.all);
    if (object.logo) {
      formData.append("logo", object.logo);
    }
    if (object.subdomain) {
      formData.append("subdomain", object.subdomain);
    }
    if (object.email) {
      formData.append("email", object.email);
    }
    if (object.phone) {
      formData.append("phone", object.phone);
    }
    if (object.address) {
      formData.append("address", object.address);
    }
    formData.append("bankname", object.bankname ? object.bankname : "");
    formData.append(
      "bankaccountname",
      object.bankaccountname ? object.bankaccountname : "",
    );
    if (object.password) {
      formData.append("password", object.password);
    }
    if (object.workfield) {
      formData.append("workfield", object.workfield);
    }
    if (object.parentagencyid) {
      formData.append("parentagencyid", object.parentagencyid);
    }
    if (object.iban) {
      formData.append("iban", object.iban);
    }
    formData.append("isdebtok", object.isdebtok ? "true" : "false");

    if (object.debtlimit >= 0) {
      formData.append("debtlimit", object.debtlimit);
    }
    if (object.whatsappgroupid) {
      formData.append("sendtowgroup", object.sendtowgroup ? "true" : "false");
      formData.append("whatsappgroupid", object.whatsappgroupid);
    }
    formData.append("active", object.active ? "true" : "false");
    formData.append(
      "forcelogodisplay",
      object.forcelogodisplay ? "true" : "false",
    );
    formData.append("username", object.username);
    formData.append("insurance_price_ratios", object.insurance_price_ratios);
    if (object.note) {
      formData.append("note", object.note);
    }
    //new agency properties
    if (object.oldcompanyname) {
      formData.append("oldcompanyname", object.oldcompanyname);
    }
    if (object.oldcompanyratio) {
      formData.append("oldcompanyratio", object.oldcompanyratio);
    }
    if (object.state) {
      formData.append("state", object.state);
    }
    if (object.loyalty) {
      formData.append("loyalty", object.loyalty);
    }
    if (object.labels) {
      formData.append("labels", object.labels.join(";"));
    }
    formData.append("hascreditcard", object.hascreditcard ? "true" : "false");
    if (object.hascreditcard) {
      formData.append("creditcardholdername", object.creditcardholdername);
      formData.append("creditcardno", object.creditcardno);
      formData.append("creditcardexpirydate", object.creditcardexpirydate);
      formData.append("creditcardcvv", object.creditcardcvv);
    }
    if (object.billingprofiles) {
      formData.append(
        "billingprofiles",
        JSON.stringify(object.billingprofiles),
      );
    }
    if (isPutMethod) {
      formData.append("_method", "PUT");
    }
    return formData;
  }
}
export default Agency;
